module.exports = __webpack_public_path__ + "static/media/Macbook3.132af3d9.png";